import { useHistory } from 'react-router-dom'
import { camelCaseToUnderscores } from '../../utils/uri.utilities'
import { SearchResultsSort } from '../../__generated__/fed-graphql-types'
import { SearchResultsFacetsWithGroupsQueryVariables } from '../../contexts/search-results-context/query/__generated__/search-results-facets.fed.query'
import { Channel } from '@at/sauron-platform-core'
import { useChannel } from '../use-abtest.hook'

const sortMap: { [x: string]: string | null } = {
    datedesc: 'most_recent',
    recent: null,
}

export function getDefaultSortOrder(channel: Channel) {
    switch (channel) {
        case Channel.bikes:
        case Channel.cars:
        case Channel.caravans:
        case Channel.cycles:
        case Channel.motorhomes:
        case Channel.vans:
        case Channel.farm:
        case Channel.plant:
        case Channel.trucks:
            return SearchResultsSort.relevance
        default:
            return SearchResultsSort.distance
    }
}

export function useQuerySortBy(): SearchResultsFacetsWithGroupsQueryVariables['sortBy'] {
    const {
        location: { search },
    } = useHistory()
    const channel = useChannel()
    const queryParams = new URLSearchParams(search)

    const sort = queryParams.get('sort')
        ? camelCaseToUnderscores((queryParams.get('sort') as string)?.replace(/-/g, '_')).toLowerCase()
        : null
    const sortBy = (sortMap[sort as string] !== undefined ? sortMap[sort as string] : sort) as SearchResultsSort

    return SearchResultsSort[sortBy] ?? getDefaultSortOrder(channel)
}
